/**
 * Ícones customizados minimalistas para a sidebar
 * Design clean e profissional
 */

import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const DashboardIcon: React.FC<IconProps> = ({ className = 'size-4', size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect x="3.5" y="4" width="7" height="4" rx="2" stroke="currentColor" strokeWidth="1.5" />
    <rect x="3.5" y="11" width="7" height="10" rx="2.5" stroke="currentColor" strokeWidth="1.5" />
    <rect x="13.5" y="4" width="7" height="10" rx="2.5" stroke="currentColor" strokeWidth="1.5" />
    <rect x="13.5" y="17" width="7" height="4" rx="2" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

export const AssociadosIcon: React.FC<IconProps> = ({ className = 'size-4', size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle
      cx="3.40426"
      cy="3.40426"
      r="3.40426"
      transform="matrix(-1 0 0 1 15.617 5)"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M6.25531 16.8594C6.25531 16.1272 6.71561 15.474 7.40517 15.2277C10.5141 14.1174 13.9114 14.1174 17.0203 15.2277C17.7099 15.474 18.1702 16.1272 18.1702 16.8594V17.979C18.1702 18.9896 17.2751 19.7659 16.2747 19.6229L15.9412 19.5753C13.4681 19.222 10.9574 19.222 8.48436 19.5753L8.15081 19.6229C7.15038 19.7659 6.25531 18.9896 6.25531 17.979V16.8594Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M17.3191 11.9028C18.7964 11.9028 19.9939 10.7052 19.9939 9.22799C19.9939 7.75076 18.7964 6.55322 17.3191 6.55322"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M20.2486 18.0051L20.5107 18.0425C21.2968 18.1548 22 17.5448 22 16.7508V15.8711C22 15.2958 21.6384 14.7826 21.0966 14.5891C20.5561 14.3961 20.0046 14.2458 19.4468 14.1382"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M6.68088 11.9028C5.20364 11.9028 4.0061 10.7052 4.0061 9.22799C4.0061 7.75076 5.20364 6.55322 6.68088 6.55322"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M3.75137 18.0051L3.48929 18.0425C2.70324 18.1548 1.99997 17.5448 1.99997 16.7508V15.8711C1.99997 15.2958 2.36164 14.7826 2.90344 14.5891C3.44389 14.3961 3.99543 14.2458 4.55316 14.1382"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const EmpresasIcon: React.FC<IconProps> = ({ className = 'size-4', size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M2 8.42871C2 7.32414 2.89543 6.42871 4 6.42871H20C21.1046 6.42871 22 7.32414 22 8.42871V10.0835C22 10.9667 21.4207 11.7453 20.5747 11.9991L13.1494 14.2267C12.3996 14.4516 11.6004 14.4516 10.8506 14.2267L3.42531 11.9991C2.57934 11.7453 2 10.9667 2 10.0835V8.42871Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M12 11.5717L12 9.85742"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.83337 11.5713L2.83337 16.9998C2.83337 19.2089 4.62424 20.9998 6.83338 20.9998H17.1667C19.3758 20.9998 21.1667 19.2089 21.1667 16.9998V11.5713"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M15.3333 6.42855V5C15.3333 3.89543 14.4379 3 13.3333 3H10.6666C9.56206 3 8.66663 3.89543 8.66663 5L8.66663 6.42855"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export const FinanceiroIcon: React.FC<IconProps> = ({ className = 'size-4', size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect x="2" y="6" width="20" height="16" rx="5" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M19 6.5C19 4.17692 16.8678 2.43898 14.5924 2.90744L5.99174 4.67817C3.66769 5.15665 2 7.20267 2 9.57546L2 13"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M6 17.5H12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 14C15 12.6193 16.1193 11.5 17.5 11.5H22V16.5H17.5C16.1193 16.5 15 15.3807 15 14Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M17.5 14H17.7"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ColoniasIcon: React.FC<IconProps> = ({ className = 'size-4', size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M2.5 10.9384C2.5 9.71422 3.06058 8.55744 4.02142 7.79888L9.52142 3.45677C10.9747 2.30948 13.0253 2.30948 14.4786 3.45677L19.9786 7.79888C20.9394 8.55744 21.5 9.71422 21.5 10.9384V17.5C21.5 19.7091 19.7091 21.5 17.5 21.5H16C15.4477 21.5 15 21.0523 15 20.5V17.5C15 16.3954 14.1046 15.5 13 15.5H11C9.89543 15.5 9 16.3954 9 17.5V20.5C9 21.0523 8.55228 21.5 8 21.5H6.5C4.29086 21.5 2.5 19.7091 2.5 17.5L2.5 10.9384Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export const ComunicacaoIcon: React.FC<IconProps> = ({ className = 'size-4', size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M3.77051 21.5605L4.02038 22.2677L4.02045 22.2677L3.77051 21.5605ZM2.23926 20.0293L2.94641 20.2792L2.94644 20.2791L2.23926 20.0293ZM3.16852 17.3984L2.46133 17.1486L3.16852 17.3984ZM3.10227 16.5628L3.76926 16.2198L3.10227 16.5628ZM7.15953 20.7511L6.79585 21.4071L7.15953 20.7511ZM6.29421 20.6685L6.04427 19.9614L6.29421 20.6685ZM12 2V2.75C17.1086 2.75 21.25 6.89137 21.25 12H22H22.75C22.75 6.06294 17.9371 1.25 12 1.25V2ZM22 12H21.25C21.25 17.1086 17.1086 21.25 12 21.25V22V22.75C17.9371 22.75 22.75 17.9371 22.75 12H22ZM12 22V21.25C10.3745 21.25 8.84932 20.8305 7.52321 20.0952L7.15953 20.7511L6.79585 21.4071C8.33835 22.2623 10.1131 22.75 12 22.75V22ZM6.29421 20.6685L6.04427 19.9614L3.52056 20.8534L3.77051 21.5605L4.02045 22.2677L6.54415 21.3756L6.29421 20.6685ZM3.77051 21.5605L3.52063 20.8534C3.16396 20.9794 2.82037 20.6358 2.94641 20.2792L2.23926 20.0293L1.53211 19.7794C0.98596 21.325 2.47479 22.8138 4.02038 22.2677L3.77051 21.5605ZM2.23926 20.0293L2.94644 20.2791L3.8757 17.6481L3.16852 17.3984L2.46133 17.1486L1.53207 19.7795L2.23926 20.0293ZM3.10227 16.5628L3.76926 16.2198C3.11877 14.9548 2.75 13.5216 2.75 12H2H1.25C1.25 13.7669 1.67882 15.4346 2.43528 16.9058L3.10227 16.5628ZM2 12H2.75C2.75 6.89137 6.89137 2.75 12 2.75V2V1.25C6.06294 1.25 1.25 6.06294 1.25 12H2ZM3.16852 17.3984L3.8757 17.6481C4.04742 17.162 3.98834 16.6459 3.76926 16.2198L3.10227 16.5628L2.43528 16.9058C2.48254 16.9977 2.4836 17.0855 2.46133 17.1486L3.16852 17.3984ZM7.15953 20.7511L7.52321 20.0952C7.08754 19.8537 6.55016 19.7826 6.04427 19.9614L6.29421 20.6685L6.54415 21.3756C6.60966 21.3525 6.7015 21.3548 6.79585 21.4071L7.15953 20.7511Z"
      fill="currentColor"
    />
    <circle cx="7.04999" cy="12.0498" r="1.25" fill="currentColor" />
    <circle cx="12.05" cy="12.0498" r="1.25" fill="currentColor" />
    <circle cx="17.05" cy="12.0498" r="1.25" fill="currentColor" />
  </svg>
);

export const AdministracaoIcon: React.FC<IconProps> = ({ className = 'size-4', size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle
      cx="3"
      cy="3"
      r="3"
      transform="matrix(-1 0 0 1 15 9)"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M12.0004 2L12.0005 1.25H12.0004V2ZM16.5004 4.9375L16.1254 5.58702L16.1255 5.58705L16.5004 4.9375ZM16.5004 19.0625L16.1255 18.413L16.1254 18.413L16.5004 19.0625ZM12.0004 22L12.0004 22.75L12.0005 22.75L12.0004 22ZM7.50043 19.0625L7.87554 18.413L7.87543 18.413L7.50043 19.0625ZM7.50043 4.9375L7.87543 5.58702L7.8755 5.58698L7.50043 4.9375ZM8.91975 3.01535L8.18889 2.84699L8.91975 3.01535ZM2.90765 9.68646L3.3847 9.10774L2.90765 9.68646ZM4.40893 18.5048L4.97818 18.0165L4.40893 18.5048ZM9.53514 21.6935L9.35077 22.4205L9.53514 21.6935ZM8.91965 20.9838L9.65047 20.8153L8.91965 20.9838ZM15.0794 20.9838L14.3487 20.8149L15.0794 20.9838ZM14.4637 21.6935L14.2793 20.9665L14.2793 20.9665L14.4637 21.6935ZM19.5899 18.505L19.0207 18.0166L19.5899 18.505ZM21.4419 8.70679L22.15 8.45987L21.4419 8.70679ZM21.0923 9.68652L21.5695 10.2651L21.0923 9.68652ZM2.90752 14.3127L2.43056 13.7339L2.90752 14.3127ZM19.5909 5.49417L19.0217 5.9825L19.5909 5.49417ZM4.4089 5.49421L3.83966 5.00588L4.4089 5.49421ZM21.4419 15.2921L22.1501 15.539L21.4419 15.2921ZM15.0793 3.01539L14.3485 3.18414L15.0793 3.01539ZM12.0004 2L12.0004 2.75C12.7878 2.75003 13.5512 2.84818 14.2794 3.03261L14.4635 2.30557L14.6477 1.57853C13.8 1.36383 12.913 1.25004 12.0005 1.25L12.0004 2ZM15.0793 3.01539L14.3485 3.18414C14.5738 4.1595 15.1878 5.04568 16.1254 5.58702L16.5004 4.9375L16.8754 4.28798C16.3137 3.96368 15.9459 3.43468 15.8101 2.84665L15.0793 3.01539ZM16.5004 4.9375L16.1255 5.58705C16.9862 6.08386 17.9618 6.1982 18.8558 5.98729L18.6836 5.25733L18.5114 4.52736C17.9727 4.65446 17.3906 4.58534 16.8754 4.28795L16.5004 4.9375ZM19.5909 5.49417L19.0217 5.9825C19.7653 6.84927 20.3503 7.85424 20.7337 8.9537L21.4419 8.70679L22.15 8.45987C21.704 7.18047 21.0236 6.01231 20.1602 5.00583L19.5909 5.49417ZM21.0923 9.68652L20.6151 9.1079C19.7832 9.79398 19.2504 10.8345 19.2504 12H20.0004H20.7504C20.7504 11.3017 21.0679 10.6788 21.5695 10.2651L21.0923 9.68652ZM20.0004 12H19.2504C19.2504 13.1656 19.7836 14.2055 20.6153 14.8913L21.0924 14.3126L21.5695 13.7339C21.0679 13.3203 20.7504 12.698 20.7504 12H20.0004ZM21.4419 15.2921L20.7337 15.0452C20.3503 16.1447 19.7648 17.1496 19.0207 18.0166L19.5899 18.505L20.159 18.9935C21.0227 17.987 21.7038 16.8189 22.1501 15.539L21.4419 15.2921ZM18.6828 18.742L18.8547 18.0119C17.9608 17.8015 16.9856 17.9164 16.1255 18.413L16.5004 19.0625L16.8754 19.712C17.3906 19.4146 17.9725 19.3453 18.5109 19.472L18.6828 18.742ZM16.5004 19.0625L16.1254 18.413C15.1881 18.9542 14.574 19.8398 14.3487 20.8149L15.0794 20.9838L15.8101 21.1527C15.946 20.565 16.3137 20.0363 16.8754 19.712L16.5004 19.0625ZM14.4637 21.6935L14.2793 20.9665C13.5509 21.1513 12.7876 21.25 12.0004 21.25L12.0004 22L12.0005 22.75C12.9135 22.75 13.8006 22.6355 14.6481 22.4205L14.4637 21.6935ZM12.0004 22V21.25C11.2126 21.25 10.4484 21.1514 9.71951 20.9665L9.53514 21.6935L9.35077 22.4205C10.199 22.6356 11.087 22.75 12.0004 22.75V22ZM8.91965 20.9838L9.65047 20.8153C9.42569 19.8406 8.81309 18.9546 7.87554 18.413L7.50043 19.0625L7.12532 19.712C7.68631 20.036 8.05323 20.5644 8.18883 21.1524L8.91965 20.9838ZM7.50043 19.0625L7.87543 18.413C7.01493 17.9162 6.03883 17.8011 5.14435 18.0118L5.3163 18.7418L5.48825 19.4718C6.02711 19.3449 6.60991 19.4144 7.12543 19.712L7.50043 19.0625ZM4.40893 18.5048L4.97818 18.0165C4.23453 17.1496 3.6494 16.1447 3.26613 15.0452L2.55793 15.2921L1.84973 15.539C2.29577 16.8186 2.97628 17.9866 3.83967 18.9931L4.40893 18.5048ZM2.90752 14.3127L3.38448 14.8915C4.2164 14.2059 4.75043 13.166 4.75043 12H4.00043H3.25043C3.25043 12.6977 2.93266 13.3201 2.43056 13.7339L2.90752 14.3127ZM4.00043 12H4.75043C4.75043 10.8341 4.21675 9.7936 3.3847 9.10774L2.90765 9.68646L2.4306 10.2652C2.93263 10.679 3.25043 11.302 3.25043 12H4.00043ZM2.55803 8.70676L3.26622 8.95368C3.64954 7.85426 4.2346 6.8493 4.97815 5.98253L4.4089 5.49421L3.83966 5.00588C2.97628 6.01234 2.29591 7.18048 1.84984 8.45984L2.55803 8.70676ZM5.31627 5.25738L5.14403 5.98733C6.0383 6.19834 7.01452 6.08406 7.87543 5.58702L7.50043 4.9375L7.12543 4.28798C6.61017 4.58546 6.02757 4.65462 5.48851 4.52742L5.31627 5.25738ZM7.50043 4.9375L7.8755 5.58698C8.81347 5.0453 9.42602 4.15867 9.65061 3.18371L8.91975 3.01535L8.18889 2.84699C8.05336 3.43533 7.68641 3.96401 7.12536 4.28802L7.50043 4.9375ZM9.5353 2.30557L9.71944 3.03261C10.4481 2.84807 11.2124 2.75 12.0004 2.75V2V1.25C11.0875 1.25 10.1996 1.36366 9.35117 1.57852L9.5353 2.30557ZM8.91975 3.01535L9.65061 3.18371C9.66608 3.11656 9.69238 3.06922 9.71275 3.04443C9.73023 3.02316 9.73329 3.0291 9.71944 3.03261L9.5353 2.30557L9.35117 1.57852C8.66029 1.7535 8.30334 2.35019 8.18889 2.84699L8.91975 3.01535ZM2.90765 9.68646L3.3847 9.10774C3.32403 9.05772 3.28879 9.00364 3.27466 8.96749C3.26278 8.93708 3.27153 8.93844 3.26622 8.95368L2.55803 8.70676L1.84984 8.45984C1.58444 9.22103 1.99559 9.9066 2.4306 10.2652L2.90765 9.68646ZM5.3163 18.7418L5.14435 18.0118C5.07747 18.0275 5.02352 18.0249 4.99226 18.0176C4.96538 18.0113 4.96908 18.0059 4.97818 18.0165L4.40893 18.5048L3.83967 18.9931C4.3022 19.5323 4.99283 19.5885 5.48825 19.4718L5.3163 18.7418ZM9.53514 21.6935L9.71951 20.9665C9.73329 20.97 9.73017 20.9759 9.71265 20.9546C9.69226 20.9298 9.66595 20.8824 9.65047 20.8153L8.91965 20.9838L8.18883 21.1524C8.30337 21.649 8.66026 22.2454 9.35077 22.4205L9.53514 21.6935ZM15.0794 20.9838L14.3487 20.8149C14.3331 20.8822 14.3067 20.9296 14.2863 20.9545C14.2687 20.9759 14.2655 20.97 14.2793 20.9665L14.4637 21.6935L14.6481 22.4205C15.3386 22.2454 15.6954 21.649 15.8101 21.1527L15.0794 20.9838ZM19.5899 18.505L19.0207 18.0166C19.0298 18.006 19.0335 18.0115 19.0066 18.0178C18.9754 18.025 18.9215 18.0277 18.8547 18.0119L18.6828 18.742L18.5109 19.472C19.0063 19.5886 19.6966 19.5323 20.159 18.9935L19.5899 18.505ZM21.4419 8.70679L20.7337 8.9537C20.7284 8.93846 20.7371 8.9371 20.7252 8.96753C20.7111 9.00371 20.6758 9.05784 20.6151 9.1079L21.0923 9.68652L21.5695 10.2651C22.0043 9.90655 22.4154 9.22104 22.15 8.45987L21.4419 8.70679ZM2.55793 15.2921L3.26613 15.0452C3.27145 15.0605 3.26271 15.0619 3.27457 15.0315C3.28868 14.9954 3.32387 14.9414 3.38448 14.8915L2.90752 14.3127L2.43056 13.7339C1.99544 14.0924 1.58442 14.7779 1.84973 15.539L2.55793 15.2921ZM18.6836 5.25733L18.8558 5.98729C18.9226 5.97154 18.9765 5.97415 19.0077 5.98142C19.0345 5.98767 19.0308 5.99311 19.0217 5.9825L19.5909 5.49417L20.1602 5.00583C19.6976 4.46667 19.007 4.41046 18.5114 4.52736L18.6836 5.25733ZM4.4089 5.49421L4.97815 5.98253C4.96904 5.99314 4.96533 5.9877 4.99215 5.98145C5.02336 5.97418 5.07724 5.97157 5.14403 5.98733L5.31627 5.25738L5.48851 4.52742C4.99293 4.41048 4.30222 4.46667 3.83966 5.00588L4.4089 5.49421ZM21.0924 14.3126L20.6153 14.8913C20.676 14.9413 20.7112 14.9953 20.7253 15.0315C20.7372 15.0618 20.7284 15.0604 20.7337 15.0452L21.4419 15.2921L22.1501 15.539C22.4155 14.7779 22.0044 14.0925 21.5695 13.7339L21.0924 14.3126ZM14.4635 2.30557L14.2794 3.03261C14.2655 3.0291 14.2686 3.02318 14.2862 3.04453C14.3066 3.0694 14.333 3.11685 14.3485 3.18414L15.0793 3.01539L15.8101 2.84665C15.6954 2.35019 15.3386 1.75352 14.6477 1.57853L14.4635 2.30557Z"
      fill="currentColor"
    />
  </svg>
);

export const LogoutIcon: React.FC<IconProps> = ({ className = 'size-4', size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M16 16V18C16 20.2091 14.2091 22 12 22H7C4.79086 22 3 20.2091 3 18V6C3 3.79086 4.79086 2 7 2H12C14.2091 2 16 3.79086 16 6V8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M19 15L21.2929 12.7071C21.6834 12.3166 21.6834 11.6834 21.2929 11.2929L19 9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M21 12L9 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

// Novos ícones solicitados
export const ColapsarIcon: React.FC<IconProps> = ({ className = 'size-4', size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      width="20"
      height="20"
      rx="5"
      transform="matrix(-1 0 0 1 22 2)"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M10 2L10 22"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SuporteIcon: React.FC<IconProps> = ({ className = 'size-4', size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M3.625 21.7002L4.09352 22.2858L4.09354 22.2858L3.625 21.7002ZM6.45216 19.4383L6.9207 20.0239L6.45216 19.4383ZM17 3V3.75C19.3472 3.75 21.25 5.65279 21.25 8H22H22.75C22.75 4.82436 20.1756 2.25 17 2.25V3ZM22 8H21.25V14H22H22.75V8H22ZM22 14H21.25C21.25 16.3472 19.3472 18.25 17 18.25V19V19.75C20.1756 19.75 22.75 17.1756 22.75 14H22ZM17 19V18.25H7.7016V19V19.75H17V19ZM6.45216 19.4383L5.98361 18.8527L3.15646 21.1146L3.625 21.7002L4.09354 22.2858L6.9207 20.0239L6.45216 19.4383ZM3.625 21.7002L3.15648 21.1145C2.99305 21.2453 2.75 21.1289 2.75 20.9189H2H1.25C1.25 22.386 2.94742 23.2027 4.09352 22.2858L3.625 21.7002ZM2 20.9189H2.75V8H2H1.25V20.9189H2ZM2 8H2.75C2.75 5.65279 4.65279 3.75 7 3.75V3V2.25C3.82436 2.25 1.25 4.82436 1.25 8H2ZM7 3V3.75H17V3V2.25H7V3ZM7.7016 19V18.25C7.07712 18.25 6.47124 18.4625 5.98361 18.8527L6.45216 19.4383L6.9207 20.0239C7.14235 19.8466 7.41775 19.75 7.7016 19.75V19Z"
      fill="currentColor"
    />
    <circle cx="7.04999" cy="11.0498" r="1.25" fill="currentColor" />
    <circle cx="12.05" cy="11.0498" r="1.25" fill="currentColor" />
    <circle cx="17.05" cy="11.0498" r="1.25" fill="currentColor" />
  </svg>
);

export const NotificacoesIcon: React.FC<IconProps> = ({ className = 'size-4', size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M11.8262 2L11.8262 1.25H11.8262V2ZM17.9131 8.08691L18.6631 8.08691L18.6631 8.08691L17.9131 8.08691ZM19.6523 14.8848L20.4023 14.8848L20.4023 14.8847L19.6523 14.8848ZM16.9189 18.083L17.022 18.8259L17.022 18.8259L16.9189 18.083ZM11.8262 18.5215L11.8262 19.2715L11.8262 19.2715L11.8262 18.5215ZM6.73242 18.083L6.62929 18.8259L6.62941 18.8259L6.73242 18.083ZM4 14.8848L3.25 14.8847L3.25 14.8848L4 14.8848ZM5.73926 8.08691L4.98926 8.08691V8.08691H5.73926ZM4.46645 13.1864L3.8222 12.8024L4.46645 13.1864ZM11.8262 2L11.8262 2.75C14.7736 2.75004 17.1631 5.13945 17.1631 8.08692L17.9131 8.08691L18.6631 8.08691C18.6631 4.31101 15.6021 1.25006 11.8262 1.25L11.8262 2ZM17.9131 8.08691H17.1631V10.1779H17.9131H18.6631V8.08691H17.9131ZM19.1858 13.1864L18.5416 13.5704C18.7706 13.9545 18.9023 14.4032 18.9023 14.8848L19.6523 14.8848L20.4023 14.8847C20.4023 14.1254 20.1936 13.4123 19.83 12.8023L19.1858 13.1864ZM19.6523 14.8848L18.9023 14.8848C18.9023 16.1307 18.0157 17.1737 16.8159 17.3401L16.9189 18.083L17.022 18.8259C18.9976 18.552 20.4023 16.8446 20.4023 14.8848L19.6523 14.8848ZM16.9189 18.083L16.8159 17.3401C15.2454 17.5579 13.3181 17.7715 11.8262 17.7715L11.8262 18.5215L11.8262 19.2715C13.4268 19.2715 15.4392 19.0454 17.022 18.8259L16.9189 18.083ZM11.8262 18.5215L11.8262 17.7715C10.3342 17.7715 8.40599 17.5579 6.83543 17.3401L6.73242 18.083L6.62941 18.8259C8.21222 19.0454 10.2255 19.2715 11.8262 19.2715L11.8262 18.5215ZM6.73242 18.083L6.83556 17.3401C5.63612 17.1736 4.75 16.1308 4.75 14.8848L4 14.8848L3.25 14.8848C3.25 16.8442 4.65384 18.5516 6.62929 18.8259L6.73242 18.083ZM4 14.8848L4.75 14.8848C4.75005 14.4032 4.88177 13.9545 5.11069 13.5704L4.46645 13.1864L3.8222 12.8024C3.45868 13.4123 3.25008 14.1254 3.25 14.8847L4 14.8848ZM5.73926 10.1778H6.48926V8.08691H5.73926H4.98926V10.1778H5.73926ZM5.73926 8.08691L6.48926 8.08692C6.48928 5.13941 8.87867 2.75 11.8262 2.75V2V1.25C8.05023 1.25 4.98928 4.31099 4.98926 8.08691L5.73926 8.08691ZM4.46645 13.1864L5.11069 13.5704C5.36525 13.1433 5.72113 12.6043 5.98521 12.0752C6.25916 11.5264 6.48926 10.8908 6.48926 10.1778H5.73926H4.98926C4.98926 10.5654 4.86468 10.9614 4.6431 11.4054C4.41164 11.8691 4.13111 12.2841 3.8222 12.8024L4.46645 13.1864ZM17.9131 10.1779H17.1631C17.1631 10.8908 17.3931 11.5264 17.6671 12.0753C17.9312 12.6044 18.287 13.1433 18.5416 13.5704L19.1858 13.1864L19.83 12.8023C19.5212 12.2841 19.2406 11.8691 19.0092 11.4054C18.7876 10.9615 18.6631 10.5655 18.6631 10.1779H17.9131Z"
      fill="currentColor"
    />
    <path
      d="M14 20.834C13.5326 21.5369 12.7335 22.0002 11.8261 22.0002C10.9187 22.0002 10.1195 21.5369 9.65218 20.834"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
